import { m } from "motion/react";
import styled, { keyframes } from "styled-components";
import Link from "next/link";

export const TitleShadow = styled.h1`
  font-family: var(--font-bolden-van);
  font-size: 2rem;
  font-weight: 900;
  color: white;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
  text-shadow: 1px 1px 0 black;
`;

export const TitleShadowHenlo = styled.h1`
  font-family: var(--font-jakarta);
  font-size: 2rem;
  font-weight: 900;
  color: white;
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    5px 5px 0 black;
  /* text-transform: uppercase; */
`;

export const TitleShadowHenlo2 = styled.h1`
  font-family: var(--font-clash);
  font-size: 2rem;
  font-weight: 900;
  color: white;
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    3px 3px 0 black;
  /* text-transform: uppercase; */
`;

export const TitleShadowBaddies = styled.h1`
  font-family: var(--font-ohno);
  font-size: 2rem;
  font-weight: 700;
  color: white;
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    3px 3px 0 black;
  /* text-transform: uppercase; */
`;

export const TitleShadowBullas = styled.h1`
  font-family: var(--font-ed);
  font-size: 2rem;
  font-weight: 900;
  color: white;
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    4px 4px 0 black;
`;

export const TitleShadowPuffpaw = styled.h1`
  font-family: var(--font-maxi);
  font-size: 2rem;
  font-weight: 900;
  color: white;
  text-shadow:
    -2px -2px 0 black,
    2px -2px 0 black,
    -2px 2px 0 black,
    4px 4px 0 black;
`;

export const TabText = styled.div<{
  selected: boolean;
  width?: string;
  noProject?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width, noProject }) => (noProject ? "25%" : width || "16.66%")};
  height: 3rem;
  border-radius: 8px;
  cursor: pointer;
  color: ${(props) => (props.selected ? "#ffffffff" : "#00000075")};
  font-family: var(--font-cabin-condensed);
  font-size: 1rem;
  z-index: 1;

  &:hover {
    color: #ffffff;
  }
`;

export const ImageContainer = styled(m.div)`
  width: 100%;
  aspect-ratio: 1/1;
  background: #ffffff;
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  outline: 0px solid #eeba02;
  z-index: 100;
  border: 4px solid black;
  box-shadow: 2px 2px 0px 0px black;
  box-sizing: border-box;
  position: relative;

  &:hover {
    outline: 6px solid #eeba02;
  }
`;

export const CategoryContainer = styled(m.div)`
  width: 100%;
  aspect-ratio: 16/9;
  background: #ffffff;
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  outline: 0px solid #eeba02;
  z-index: 100;
  border: 4px solid black;
  /* box-shadow: 2px 2px 0px 0px black; */
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  &:hover {
    outline: 6px solid #eeba02;
  }
`;

export const UploadImageContainer = styled(m.div)`
  height: auto;
  background: #ccc;
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  outline: 0px solid #eeba02;
  z-index: 100;
  border: 4px solid black;
  box-shadow: 2px 2px 0px 0px black;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 8px;
  padding: 12px 24px;

  &:hover {
    outline: 6px solid #eeba02;
  }
`;

export const PopupBtn = styled(m.div)<{ color: string }>`
  height: auto;
  background: ${({ color }) => color};
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  z-index: 100;
  border: 4px solid black;
  box-shadow: 2px 2px 0px 0px black;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 8px;
  padding: 12px 32px;
`;

export const MobileBackBtn = styled(m.div)`
  height: 36px;
  background: #ccc;
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  outline: 0px solid #eeba02;
  z-index: 100;
  border: 4px solid black;
  box-shadow: 2px 2px 0px 0px black;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 8px;
  padding: 0px 8px;

  &:hover {
    outline: 6px solid #eeba02;
  }
`;

export const NotificationContainer = styled(m.div)`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: starts;
  background: #ffffff;
  box-sizing: border-box;
  padding: 12px 16px;
  gap: 6px;
  height: auto;
  font-family: var(--font-cabin-condensed);
  font-size: 1rem;
  border-radius: 0.25rem;
  box-shadow: 2px 2px 0px 0px #000000;
  border: 4px solid #000000;
`;

export const RouteWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageFormatContainer = styled(m.div)`
  width: 33%;
  aspect-ratio: 1/1;
  background: #ccc;
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  outline: 0px solid #eeba02;
  z-index: 100;
  border: 4px solid black;
  box-shadow: 2px 2px 0px 0px black;
  box-sizing: border-box;
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  padding: 16px;
  gap: 4px;

  &:hover {
    outline: 6px solid #eeba02;
  }
`;

export const ToolbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  height: 100%;
  margin-bottom: 8px;
`;

export const CloseButton = styled(m.div)`
  cursor: pointer;
  background: ${({ color }) => color};
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid black;
  width: 16px;
  height: 16px;
  color: #000000;

  &:hover {
    background: ${({ color }) => `${color}95`};
  }
`;

export const PopupContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #00000075;
  z-index: 100;
`;

export const PopupContent = styled(m.div)`
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ccc;
  z-index: 100;
  border-radius: 0.25rem;
  box-sizing: border-box;
  padding: 32px;
  overflow: hidden;
  border: 4px solid black;
  box-shadow: 2px 2px 0px 0px black;
  font-family: var(--font-cabin-condensed);
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 640px) {
    width: 75%;
  }
`;

export const TabLogo = styled.div<{ selected: boolean; invert?: boolean }>`
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.selected ? "1" : "0.5")};
  filter: ${(props) =>
    props.selected
      ? "invert(0) grayscale(0)"
      : `invert(${props.invert ? 1 : 0}) grayscale(1)`};
  z-index: 1;

  &:hover {
    opacity: 1;
    filter: invert(0) grayscale(0);
  }
`;

export const MemeGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  box-sizing: border-box;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
`;

export const CategoryGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  box-sizing: border-box;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const BannerTemplateGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  box-sizing: border-box;
  gap: 16px;

  /* Each item in the grid will maintain 3:1 aspect ratio */
  > * {
    aspect-ratio: 3/1 !important;
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const GalleryGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  box-sizing: border-box;
  gap: 16px;

  @media (min-width: 1280px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
`;

const load = keyframes`
  0% {
    background-color: #d9a253;
  }
  100% {
    background-color: #945700;
  }
`;

export const SkeletonLoader = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  background: #ffffff;
  border-radius: 0.25rem;
  position: relative;
  cursor: pointer;
  outline: 0px solid #eeba02;
  z-index: 100;
  border: 4px solid black;
  box-shadow: 2px 2px 0px 0px black;
  box-sizing: border-box;
  position: relative;
  animation: ${load} 1s linear infinite alternate;
`;

export const HoverBtn = styled.div<{ color?: string; hoverColor?: string }>`
  width: 16px;
  height: 16px;
  background: ${({ color }) => color || "#cccccc"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid black;
  border-radius: 4px;

  &:hover {
    background: ${({ hoverColor }) => hoverColor || "#DBDBDB"};
  }
`;

export const Banner = styled.div`
  width: 100%;
  /* background: #ffb502; */
  /* padding: 16px; */
  height: 64px;
  box-sizing: border-box;
  color: #000000;
  font-family: var(--font-cabin-condensed);
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MobileHoverBtn = styled(m.div)<{
  color?: string;
  disabled?: boolean;
  small?: boolean;
}>`
  padding: ${({ small }) => (small ? "2px" : "4px")};
  box-sizing: border-box;
  background: ${({ color }) => color || "#cccccc"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  border: 2px solid black;
  border-radius: 4px;
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
`;

export const CustomTab = styled(m.div)<{
  currentMode: "asset" | "draw" | "text" | "upload" | "layers";
  mode: "asset" | "draw" | "text" | "upload" | "layers";
}>`
  width: 100%;
  height: 100%;
  padding: 8px;
  border: none;
  box-sizing: border-box;
  background: ${({ currentMode, mode }) =>
    currentMode === mode ? "#00000025" : "#ccc"};
  cursor: pointer;
  font-family: var(--font-cabin-condensed);
  font-size: 1rem;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${({ currentMode, mode }) =>
    currentMode === mode ? "#000000" : "#00000075"};

  &:hover {
    color: #000000;
  }
`;

export const NavLink = styled(Link)<{ $isActive: boolean }>`
  color: #000;
  text-decoration: ${({ $isActive }) => ($isActive ? "underline" : "none")};
  font-family: var(--font-cabin-condensed);
  font-size: 1.1rem;
  font-weight: 500;
  opacity: 1;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.6;
  }
`;
